import { LocalStorageService } from './../../../services/localStorage/localStorage.service';
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable @typescript-eslint/naming-convention */
import {
  Component,
  ElementRef,
  Inject,
  NgZone,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { GoogleMap } from '@capacitor/google-maps';
import { ModalController } from '@ionic/angular';
import { Geolocation } from '@capacitor/geolocation';
import { DynamicAddressInputComponent } from '../dynamic-address-input/dynamic-address-input.component';
import { UiService } from 'src/app/services/ui.service';
import { DOCUMENT } from '@angular/common';
import { localStorageKeys } from 'src/app/services/localStorage/localStorageVariables';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

declare var google: any;

@Component({
  selector: 'address-selector-modal',
  templateUrl: './address-selector-modal.component.html',
  styleUrls: ['./address-selector-modal.component.scss'],
})
export class AddressSelectorModalComponent implements OnInit {
  @ViewChild('dynamicAddressInput')
  dynamicAddressInput!: DynamicAddressInputComponent;
  public currentHeaderData: any;
  address: any;
  phone: any;
  formattedAddress: any;
  structuredAddress: any;
  establishmentAddress!: any;
  formattedEstablishmentAddress!: string;
  latlon: any;
  @ViewChild('map')
  mapRef!: ElementRef<HTMLElement>;
  map!: GoogleMap;
  showMarker: boolean;
  showAddressInput!: boolean;
  AddressForm: FormGroup;
  showLoading!: boolean;
  latlong: any = {
    latitude: '',
    longitude: '',
    timestamp: '',
  };

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private uiService: UiService,
    public zone: NgZone,
    private modalController: ModalController,
    private localStorageService: LocalStorageService,
    private analyticsService: AnalyticsService
  ) {
    this.showMarker = false;
    this.AddressForm = new FormGroup({
      street: new FormControl('', [Validators.required]),
      line2: new FormControl(''),
      landmark: new FormControl(''),
      city_name: new FormControl('', [Validators.required]),
      postal_code: new FormControl('', [Validators.required]),
      formatted_address: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit() {
    this.showAddressInput = false;
    this.currentHeaderData = {
      modalSlotEnd: true,
      marl20: true,
      title: 'modals.address_selector_modal.header',
    };
    const latlong = JSON.parse(
      this.localStorageService.getItem(localStorageKeys.LAT_LONG_DATA)
    );
    if (latlong?.latitude && latlong?.longitude) {
      setTimeout(() => {
        this.createMap(latlong.latitude, latlong.longitude);
      });
    } else {
      this.showMapWithCurrentLocation();
    }
  }
  ngOnDestroy() {
    this.map.destroy();
    this.document.body.classList.remove('maps-active');
  }
  closeModal() {
    this.analyticsService.trackUnified('address_selector_closed', {
      flow: 'address',
      outcome: 'success',
      legacy_event_name: 'button_click',
      button: 'address-selector-modal-close-button',
    });
    this.modalController.dismiss();
  }

  async getCurrentPosition() {
    const coordinates = await Geolocation.getCurrentPosition();
    return coordinates;
  }

  async getLocationPermission() {
    this.showLoading = true;
    const permission = await Geolocation.checkPermissions();
    this.showLoading = false;
    if (permission.location === 'granted') {
      // Location permission granted
      // Add your code here
      return true;
    } else if (permission.location === 'prompt') {
      Geolocation.requestPermissions({
        permissions: ['location', 'coarseLocation'],
      });
      // Location permission prompt
      // Add your code here
      return true;
    } else {
      // Location permission denied
      // Add your code here
      this.uiService.presentToast('Location access denied');
      return false;
    }
  }

  async showMapWithCurrentLocation() {
    this.analyticsService.trackUnified('current_location_clicked', {
      flow: 'address',
      outcome: 'success',
      legacy_event_name: 'button_click',
      text: 'Current Location',
    });
    if (!(await this.getLocationPermission())) {
      return;
    }
    this.dynamicAddressInput.resetInput();
    const coordinates = await this.getCurrentPosition();
    this.createMap(coordinates.coords.latitude, coordinates.coords.longitude);
  }

  async createMap(lat: number, lng: number) {
    this.document.body.classList.add('maps-active');
    if (!this.map) {
      this.map = await GoogleMap.create({
        id: 'my-cool-map',
        element: this.mapRef.nativeElement,
        apiKey: 'AIzaSyDPA4oYM0GalL1T7f5YjKyCwV8VGpI1V4E',
        config: {
          center: {
            lat,
            lng,
          },
          zoom: 16,
        },
      });
      this.showMarker = true;
      this.map.setOnCameraIdleListener(async (CameraIdleCallbackData) => {
        this.latlong.latitude = CameraIdleCallbackData?.latitude;
        this.latlong.longitude = CameraIdleCallbackData?.longitude;
        this.latlong.timestamp = '';
        if(google){

          let data = await new google.maps.Geocoder().geocode(
            {
              location: {
                lat: CameraIdleCallbackData.latitude,
                lng: CameraIdleCallbackData.longitude,
              },
            },
            (results, status) => {
              if (status === google?.maps.GeocoderStatus.OK) {
                this.zone.run(async () => {
                  this.structuredAddress = await this.generateAddressObject(
                    results
                  );
                  this.localStorageService.setItem(
                    localStorageKeys.ADDRESS,
                    JSON.stringify(this.structuredAddress)
                  );
                  this.AddressForm.patchValue({
                    street: this.structuredAddress.street,
                    line2: this.structuredAddress.line2,
                    landmark: this.structuredAddress.landmark,
                    city_name: this.structuredAddress.city_name,
                    postal_code: this.structuredAddress.postal_code,
                    formatted_address: this.structuredAddress.formatted_address,
                  });
                });
              }
            }
          );
        }
      });
    } else {
      this.map.setCamera({
        coordinate: {
          lat,
          lng,
        },
        zoom: 16,
      });
    }
  }

  async getAddress(place: any) {
    this.analyticsService.trackUnified('address_search', {
      flow: 'address',
      outcome: 'success',
      legacy_event_name: 'search',
      search:
        place.geometry.location.lat() + '' + place.geometry.location.lat(),
    });
    if (place?.geometry?.location?.lat() || place?.geometry?.location?.lng()) {
      const loader = await this.uiService.presentGlobalLoading(
        'Loading Map...'
      );
      await this.createMap(
        place.geometry.location.lat(),
        place.geometry.location.lng()
      );
      loader.dismiss();
      this.showMarker = true;
    }

    // // this.registerFormGroup
    // //   .get('branch.address.street')
    // //   ?.patchValue(this.formattedAddress.street);
    // // this.registerFormGroup
    // //   .get('branch.address.line2')
    // //   ?.patchValue(this.formattedAddress.line2);
    // // this.registerFormGroup
    // //   .get('branch.address.landmark')
    // //   ?.patchValue(this.formattedAddress.landmark);
    // // this.registerFormGroup
    // //   .get('branch.address.city_name')
    // //   ?.patchValue(this.formattedAddress.city_name);
    // // this.registerFormGroup
    // //   .get('branch.address.postal_code')
    // //   ?.patchValue(this.formattedAddress.postal_code);
  }

  cleanAddressComponents(data: any) {
    if (data.length === 0) {
      return;
    }
    const closestAddres = data.filter(
      (obj: any) => obj.types && obj.types.includes('street_address')
    ) || [...data[0]];
    const address_components = closestAddres?.[0]?.address_components;
    const componentsByType: { [key: string]: any } = {};

    for (let i = 0; i < address_components.length; i++) {
      const c = address_components[i];
      if (!componentsByType[c.types[0]] || componentsByType[c.types[0]] == '') {
        componentsByType[c.types[0]] = c;
      }
    }
    return componentsByType;
  }
  generateAddressObject(data: any): any {
    const closestAddres =
      data.filter(
        (obj: any) =>
          obj.types &&
          (obj.types.includes('street_address') ||
            obj.types.includes('locality'))
      ) || data[0];
    const address_components = closestAddres?.[0]?.address_components;
    const output = {
      street: '',
      line2: '',
      landmark: '',
      city_name: '',
      postal_code: '',
      formatted_address: '',
    };
    let premise = '';
    let street_number = '';
    let route = '';
    let sublocality_level_1 = '';
    let sublocality_level_2 = '';
    if (address_components === undefined) return output;
    Object.keys(address_components).forEach((item) => {
      if (address_components[item].types.includes('postal_code')) {
        output.postal_code = address_components[item].long_name;
      }
      if (
        address_components[item].types.includes('administrative_area_level_3')
      ) {
        output.city_name = address_components[item].long_name;
      }
      if (address_components[item].types.includes('establishment')) {
        output.landmark = address_components[item].long_name;
      }
      if (address_components[item].types.includes('route')) {
        route = address_components[item].long_name;
      }
      if (address_components[item].types.includes('street_number')) {
        street_number = address_components[item].long_name;
      }
      if (address_components[item].types.includes('premise')) {
        premise = address_components[item].long_name;
      }
      if (address_components[item].types.includes('sublocality_level_1')) {
        sublocality_level_1 = address_components[item].long_name;
      }
      if (address_components[item].types.includes('sublocality_level_2')) {
        sublocality_level_2 = address_components[item].long_name;
      }
    });
    const objectValues = Object.values(output).join(' ').toLowerCase();
    const addressWords = closestAddres[0].formatted_address.split(',');
    output.formatted_address = closestAddres[0].formatted_address;
    let notInObject = '';
    for (let word of addressWords) {
      word = word.trim();
      if (!objectValues.includes(word.toLowerCase())) {
        notInObject = word;
        break;
      }
    }
    output.street = [notInObject, premise, street_number, route]
      .filter(Boolean)
      .join(', ');
    output.line2 = `${sublocality_level_2}, ${sublocality_level_1}`;

    return output;
  }
  addCompleteAddress() {
    this.showAddressInput = true;
  }
  saveAddress() {
    this.analyticsService.trackUnified('address_confirm_clicked', {
      flow: 'address',
      outcome: 'success',
      legacy_event_name: 'button_clicked',
      button: 'Confirm',
    });
    this.modalController.dismiss({
      address: this.AddressForm.value,
      latlong: this.latlong,
    });
  }
}
